import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_select, {
      ref: "refSelecionarCst",
      class: _normalizeClass('ss-tamanho-completo ' + _ctx.props.classCss),
      value: _ctx.computedCodigoSelecionado,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedCodigoSelecionado) = $event)),
      "show-search": "",
      allowClear: true,
      placeholder: _ctx.props.placeholder,
      optionFilterProp: "label",
      "not-found-content": _ctx.state.buscandoDados ? undefined : null,
      options: _ctx.state.listaCst,
      disabled: _ctx.props.disabled,
      onChange: _ctx.change,
      onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pesquisarCst(''))),
      onSearch: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pesquisarCst($event))),
      onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.emDigitacao = false))
    }, _createSlots({ _: 2 }, [
      (_ctx.state.buscandoDados)
        ? {
            name: "notFoundContent",
            fn: _withCtx(() => [
              _createTextVNode(" Buscando CSTs "),
              _createVNode(_component_a_spin)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["class", "value", "placeholder", "not-found-content", "options", "disabled", "onChange"])
  ]))
}